import Badge from 'client/components/core/Badge'
import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import CommonBlogPostCategories from 'common/components/entities/BlogPostCategories/BlogPostCategoriesNew'
import { BlogPostCategoriesInterface } from 'common/types/entities/BlogPostCategoriesInterface'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { EntityProps } from '../../../types'

const categories = ['Lorem', 'Ipsum']

function BlogPostCategoriesNew({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: EntityProps<BlogPostCategoriesInterface>) {
  const { t } = useTranslation()

  return (
    <BaseEntityNew
      entity={entity}
      isMoveUpAllowed={isMoveUpAllowed}
      isMoveDownAllowed={isMoveDownAllowed}
    >
      <>
        <CommonBlogPostCategories
          categories={categories}
          attrId={entity.htmlAttrId}
          fontSize={entity.fontSize}
          fontFamily={entity.fontFamily}
          fontStyle={entity.fontStyle}
          fontWeight={entity.fontWeight}
          mobileFontSize={entity.mobileFontSize}
          mobileFontFamily={entity.mobileFontFamily}
          mobileFontStyle={entity.mobileFontStyle}
          mobileFontWeight={entity.mobileFontWeight}
          lineHeight={entity.lineHeight}
          mobileLineHeight={entity.mobileLineHeight}
          color={entity.color}
          mobileColor={entity.mobileColor}
          alignSelf={entity.alignSelf}
          mobileAlignSelf={entity.mobileAlignSelf}
        />
        <Badge wide>
          {t('entities.blog_post_date.warnings.do_not_remove')}
        </Badge>
      </>
    </BaseEntityNew>
  )
}

export default BlogPostCategoriesNew
